import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { TableFilterMenu } from '@interxfi/design-system/components/table/filter/table-filter-menu';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import {
  IncomeStatement,
  type IncomeStatementFilterableField,
} from '../../../../../../../../../../features/accounting/income-statement/income-statement';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceAccounting,
      label: 'Income Statement',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceAccounting>,
  head: () => getPageHead('Income Statement'),
  component: AccountingIncomeStatement,
});

function TableHeader({ filterProps }: CustomTableHeaderProps<IncomeStatementFilterableField>) {
  return (
    <PageTabRail
      actions={
        filterProps ? (
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <TableFilterMenu<IncomeStatementFilterableField> {...filterProps} />
          </HorizontalStack>
        ) : null
      }
      group={TabbedNavigationGroup.ClearingFinanceAccounting}
    />
  );
}

function AccountingIncomeStatement() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <IncomeStatement HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
